// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	ToggleChecklistTaskCheckbox: 'toggle-checklist-task-checkbox',
	DeleteIcon: 'delete-icon',
	DownIcon: 'down-icon',
	InfoSquareIcon: 'info-square-icon',
	SortIcon: 'sort-icon',
	DeleteIcon1: 'delete-icon-1',
	AddIcon: 'add-icon',
	NewTask: 'new-task',
	ToggleStageDiv: 'toggle-stage-div',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
